/**
 * Vue Filter - Number name
 */

/**
 * Convert number to Number name format.
 *
 * @param {number} val Number value
 * @param {boolean} usePref Use prefix
 */

import { convertNumberName } from "../utils"

export default function numberName(val = 0, ) {
	val = Number(val)

	return convertNumberName(val)
}
